import { useNavigate } from 'react-router-dom';
import { routeBase } from '../api/collections';
import { Button } from '../ui/Button';
import { IconPencil } from '../ui/icons';

/** The details editor of a study, by public id. */
export function detailsRoute(base: string, studyId: string): string {
  return `${base}/studies/${encodeURIComponent(studyId)}/details`;
}

/**
 * Whether the study's details can be edited from here: by an admin or member
 * of its workspace (the head's `editable`), and never through a share link,
 * whoever holds it. The server refuses everyone else anyway; the page just does
 * not offer it.
 */
export function canEditDetails(head: { editable?: boolean } | null | undefined, share?: unknown): boolean {
  return !share && head?.editable === true;
}

/** The viewer bar's utility action: a ghost pencil (PRODUCT_RULES, Buttons). */
export function EditDetailsButton({ head, share }: { head: { public_id: string; editable?: boolean }; share?: unknown }) {
  const nav = useNavigate();
  if (!canEditDetails(head, share)) return null;
  return (
    <Button
      variant="ghostIcon"
      size={30}
      title="Edit details"
      aria-label="Edit details"
      icon={<IconPencil size={14} />}
      onClick={(e) => {
        e.stopPropagation();
        nav(detailsRoute(routeBase(), head.public_id));
      }}
    />
  );
}
